import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "p-3 h-100 w-100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_layout__layout_postbuch = _resolveComponent("g-layout__layout-postbuch");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        "show-header": false,
        "class-content": "content__no-marging content__no-overflow"
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: "Schließen",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.currentWindow.close(2))),
                type: "normal",
                class: "w-120-px"
            })
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_g_layout__layout_postbuch, {
                    "is-hosted": "true",
                    "context-id": _ctx.contextId,
                    "item-id": _ctx.itemId,
                    mode: _ctx.sMode,
                    ref: "__view"
                }, null, 8, ["context-id", "item-id", "mode"])
            ])
        ]),
        _: 1
    }));
}
